import React from 'react';
import DashboardIcon from "@mui/icons-material/Dashboard";
import PeopleIcon from "@mui/icons-material/People";
import Inventory2OutlinedIcon from '@mui/icons-material/Inventory2Outlined';
import BusinessIcon from '@mui/icons-material/Business';
import LanguageIcon from '@mui/icons-material/Language';
import PsychologyIcon from '@mui/icons-material/Psychology';
import ContactPhoneIcon from '@mui/icons-material/ContactPhone';
import HelpIcon from '@mui/icons-material/Help';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import CardGiftcardIcon from '@mui/icons-material/CardGiftcard';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import BrushIcon from '@mui/icons-material/Brush';

// Function to get default sidebar data with icons
export const getDefaultSidebarData = () => [

  {
    id: 'categories',
    title: "Categories",
    path: "/",
    icon: <Inventory2OutlinedIcon />,
  },
  {
    id: 'enquiries',
    title: "Enquiries",
    path: "/enquiries",
    icon: <PeopleIcon />,
  },
  {
    id: 'success-stories',
    title: "Success Stories",
    path: "/success-stories",
    icon: <BrushIcon />,
  },
];

// Helper function to get sidebar items for search (with icons)
export const getSidebarItemsForSearch = () => {
  return getDefaultSidebarData().map(item => ({
    id: item.id,
    title: item.title,
    path: item.path,
    icon: item.icon
  }));
};

